import React, { useEffect, useMemo, useState } from "react";
import DynamicModulesContext from "./DynamicModulesContext";
import FactoryService from "../../../api/factoryService";
import Loader from "../../../Layout/Loader";

const STORAGE_KEY = "activeModules";

const DynamicModulesProvider = (props) => {
  const userData = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("userData")) || null;
    } catch {
      return null;
    }
  }, []);

  const factoryID = userData?.factory?.id ?? 0;

  const [AllActiveModules, setAllActiveModules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const GetFactoryModules = async (id) => {
    if (!id || id === 0) {
      setAllActiveModules([]);
      localStorage.removeItem(STORAGE_KEY);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError("");
    try {
      const res = await FactoryService.get_facotry_modules(id);
      if (res?.status === 200) {
        const FactoryModules =
          res?.data?.modules?.map((e) => e?.module_name || "N/A") || [];
        setAllActiveModules(FactoryModules);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(FactoryModules));
      } else {
        setError("Failed to load modules");
      }
    } catch (err) {
      console.log(err);
      setError("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    GetFactoryModules(factoryID);
  }, [factoryID]);

  return (
    <DynamicModulesContext.Provider
      value={{
        AllActiveModules,
        setAllActiveModules,
        loading,
        error,
        refetch: () => GetFactoryModules(factoryID),
      }}
    >
      {loading ? ( 
        <Loader/>
      ) : error ? (
        <div style={{ color: "red", textAlign: "center" }}>{error}</div>
      ) : (
        props.children
      )}
    </DynamicModulesContext.Provider>
  );
};

export default DynamicModulesProvider;
